<template>
  <div class="strategy_list">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <div v-if="!isPageError">
        <van-search shape="round" :left-icon="require('../../assets/iconImage/ic_20_search@2x.png')" placeholder="搜索攻略内容" @click="toSearchPage" />
        <div class="list_container">
          <div class="list">
            <van-list v-if="!isEmptyData" v-model="loading" :finished="finished" finished-text="没有更多了..." @load="onLoad" :immediate-check="false">
              <left-img :isShowPark="isShowPark" :imageWidth="75" :imageHeight="100" v-for="(item,index) in listData" :item="item" @itemClick="toDetail(item.id)" :key="index"> </left-img>
            </van-list>
            <van-empty v-else class="custom-image" :image="require('../../assets/img/data_empty.png')" description="暂无数据" />
          </div>
        </div>
      </div>
      <page-error v-else></page-error>
    </div>
  </div>
</template>

<script>
import TabCheckout from '@/components/TabCheckout';
import LeftImg from '@/components/LeftImgRightText';
import PageError from '../../components/PageError';
import Loading from '@/components/loading';
export default {
  name: "line_list",
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      listData: [],
      // 是否在加载中
      loading: true,
      // 是否已加载完成
      finished: false,
      // 数据是否为空
      isEmptyData: false,
      isPageError: false,
      isLoading: true,
      isShowPark:true
    };
  },
  components: {
    LeftImg,
    PageError,
    Loading
  },
  mounted() {
    this.getListData();
    this.isShowPark = this.$route.query.dataType != 2;
     console.log(this.$route.query.dataType);
  },
  methods: {
    /**
    * 点击 跳转搜索页
    */
    toSearchPage() {
      this.$router.push({
        path: '/bigSearch',
        query: {
          type: 6,
          judge: 1
        }
      });
    },
    
    /**
     * 跳转详情 
     */
    toDetail(id) {
      console.log(id)
      console.log('详情');
      this.$router.push({
        path: '/strategyDetails',
        query: {
          id: id,
        },
      });
    },
    /**
     * 请求列表数据
     */
    getListData() {
      this.loading = true;
      this.finished = false;
      this.$request.get(`/appserver/v1/strategy/list?pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&scenicId=${this.$route.query.scenicId ? this.$route.query.scenicId : ''}&dataType=${this.$route.query.dataType?this.$route.query.dataType:1}`).then((res) => {
        if (res.data.ret == 0) {
          let resData = res.data.data;
          console.log(resData, 'list数组');
          // 列表数据获取
          if (resData) {
            let list = this.listData;
            this.listData = list.concat(resData);
          }
          // 数据为空
          if (this.pageIndex == 1 && resData.length == 0) {
            console.log('数据为空');
            this.loading = false;
            this.finished = true;
            this.isEmptyData = true;
          }
          //   数据已加载完毕
          if ((!resData || resData.length == 0) && this.listData.length > 0) {
            console.log('数据已加载完毕');
            this.finished = true;
          }
          this.loading = false;
          this.isLoading = false;
        }

      }).catch((e) => {
        // this.$toast('网络不稳定，请稍后重试');
        this.isLoading = false;
        this.isPageError = true;
      });
    },
    onLoad() {
      this.pageIndex++;
      this.getListData();
    }

  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.strategy_list {
  .van-field__control {
    color: #787878;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
  .list_container {
    padding-left: 20px;
    padding-top: 20px;
    padding-right: 20px;
    .list {
      margin-top: 10px;
    }
  }
}
/deep/.van-empty__image {
  width: 245px;
  height: 170px;
}
</style>
